import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MessageTemplate,
  MessageTemplateCreateRequest,
  MessageTemplateCreateResponse,
  MessateTemplateUpdateResponse,
  WabaMessageTemplates,
} from '../types/interfaces/message-templates';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MessageTemplatesService {
  private http = inject(HttpClient);

  uploadTemplateMedia(
    wabaId: string,
    file: File
  ): Observable<{ header_handle: string }> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<{ header_handle: string }>(
      `${environment.apiHost}/message-templates/waba/${wabaId}/media`,
      formData,
      {
        withCredentials: true,
      }
    );
  }

  getAllTemplates(): Observable<WabaMessageTemplates[]> {
    return this.http.get<WabaMessageTemplates[]>(
      `${environment.apiHost}/message-templates/`,
      {
        withCredentials: true,
      }
    );
  }

  getTemplates(wabaId: string): Observable<MessageTemplate[]> {
    return this.http.get<MessageTemplate[]>(
      `${environment.apiHost}/message-templates/waba/${wabaId}`,
      {
        withCredentials: true,
      }
    );
  }

  getTemplatesByQueue(
    queueId: number | undefined
  ): Observable<MessageTemplate[]> {
    if (queueId) {
      return this.http.get<MessageTemplate[]>(
        `${environment.apiHost}/message-templates/queue/${queueId}`,
        {
          withCredentials: true,
        }
      );
    }

    return this.http.get<MessageTemplate[]>(
      `${environment.apiHost}/message-templates/queue`,
      {
        withCredentials: true,
      }
    );
  }

  getTemplatesForTicket(ticketId: number): Observable<MessageTemplate[]> {
    return this.http.get<MessageTemplate[]>(
      `${environment.apiHost}/message-templates/ticket/${ticketId}`,
      {
        withCredentials: true,
      }
    );
  }

  createTemplate(
    wabaId: string,
    template: MessageTemplateCreateRequest,
    file?: File
  ): Observable<MessageTemplateCreateResponse> {
    const formData = new FormData();
    file && formData.append('file', file);
    formData.append('templateData', JSON.stringify(template));

    return this.http.post<MessageTemplateCreateResponse>(
      `${environment.apiHost}/message-templates/waba/${wabaId}`,
      formData,
      {
        withCredentials: true,
      }
    );
  }

  updateTemplate(
    wabaId: string,
    template: MessageTemplateCreateRequest,
    file?: File
  ): Observable<MessateTemplateUpdateResponse> {
    const formData = new FormData();
    file && formData.append('file', file);
    formData.append('templateData', JSON.stringify(template));

    return this.http.put<MessateTemplateUpdateResponse>(
      `${environment.apiHost}/message-templates/waba/${wabaId}`,
      formData,
      {
        withCredentials: true,
      }
    );
  }

  deleteTemplate(
    wabaId: string,
    templateName: string
  ): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(
      `${environment.apiHost}/message-templates/waba/${wabaId}/${templateName}`,
      {
        withCredentials: true,
      }
    );
  }

  // sendTemplate(ticketId: number, templateId: string) {
  //   return this.http.post(
  //     `${environment.apiHost}/message-templates/send/${templateId}`,
  //     { ticketId: ticketId }
  //   );
  // }
}
